import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=3a97749c&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=3a97749c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a97749c",
  null
  
)

export default component.exports